/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_7_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a predictable file-exchange routine`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_7_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立可重复的文件交换流程`)
};

/**
* | output |
* | --- |
* | "Build a predictable file-exchange routine" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_7_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_7_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_7_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_7_title as "gc.search_guides.gridcraft_excel_compatibility.sections.7.title" }